import React from 'react';
import classNames from 'classnames';
import {Button} from "reactstrap";
import "./CountButton.scss";
import {Icon} from "../icon/index";

export default class CountButton extends React.Component {
    static propTypes = {
        count: React.PropTypes.number,
        type: React.PropTypes.string,
        icon: React.PropTypes.string,
        colorCount: React.PropTypes.string,
        colorContent: React.PropTypes.string,
        colorTextCount: React.PropTypes.string,
        // component:
    };

    static defaultProps = {
        type: "box",
        component: "A"
    };

    render() {
        const {component, type, count, colorCount, colorContent, icon, children, className, colorTextCount, onClick, ...other} = this.props;

        const showIcon = type !== "circle" && icon;

        const child = <div className={className ? className + " count-button " + type : "count-button " + type} {...other}>
            {(showIcon || (typeof count !== "undefined" && count !== null)) && <div className={"count-button-count " + colorCount + " " + (colorTextCount && colorTextCount + "-text")}>
                {showIcon && <Icon size="3x" icon={icon}/>}
                <span className="count-button-count-label">{count}</span>
            </div>}
            <div className={"count-button-content w-" + (showIcon ? "75 " : "100 ") + colorContent}><span className="count-button-text">{children}</span></div>
        </div>;

        return React.createElement(component, {onClick}, child);
    }
}
